export default {
  title: 'New brand',
  tabs: {
    general: 'General',
    branding: 'Branding',
    scripts: 'Scripts',
    tracking: 'Tracking',
    domain: 'Domain',
  },
  fields: {
    name: {
      label: 'Name',
      placeholder: 'Brand name',
    },
    slug: {
      label: 'Subdomain',
      placeholder: 'Brand subdomain',
      hint: 'Lowercase letters, numbers and hyphens. Together with the shop domain it forms the shop address.',
      preview: 'Shop address: {{url}}',
      availability: {
        taken: 'Another brand already uses this subdomain on this shop domain.',
        reserved: 'This subdomain is reserved. Choose another one.',
        invalid_label:
          'On this shop domain the subdomain may only use lowercase letters, numbers and hyphens, must start and end with a letter or number, and can be at most 63 characters long.',
        taken_elsewhere: 'A brand on another shop domain already uses this subdomain. Choose another one.',
        format: 'Use only letters, numbers, hyphens and underscores.',
        unavailable: 'This subdomain is not available. Choose another one.',
      },
    },
    shop_domain_id: {
      label: 'Shop domain',
      placeholder: 'Select a shop domain',
      move_warning: {
        title: 'This changes the shop address customers use',
        description:
          'After saving, the shop is at {{url}}. QR codes, flyers and links already printed or shared with the old address stop working.',
      },
    },
    lieferando_url: {
      label: 'Lieferando URL',
      placeholder: 'URL of the restaurant in Lieferando',
    },
    primary_color: {
      label: 'Primary color',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Image',
    },
    companies: {
      label: 'Restaurants',
    },
    noscripts: {
      description: 'Inject code immediately after opening body',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion Access Token',
    },
    google_analytics_id: {
      label: 'Google analytics ID',
    },
    google_ads_conversion_label_id: {
      label: 'Google ads conversion label',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Own domain for the online shop',
    },
  },
  buttons: {
    save: 'Save',
    close: 'Close',
    sync_from_lieferando: 'Sync from Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Changes have been successfully saved!',
    failed_to_update_company_slug: 'Failed to update slug for {{name}}',
    failed_to_sync_lieferando: 'Failed to sync details from Lieferando',
    successfully_synced_lieferando: 'Data successfully synced from Lieferando',
    failed_to_load_shop_domains: 'Could not load the shop domains.',
  },
};
